import { AnimatePresence, motion } from 'framer-motion';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setCanScroll } from '../../redux/globals/globals.actions';
import SvgIcon from '../svg-icon/svg-icon.component';
import './popup.scss';

const Popup = ({ handleClose, children, title }) => {
	useEffect(() => {
		document.body.style.top = `-${window.scrollY}px`;
		document.body.style.width = '100%';
		document.body.style.position = 'fixed';

		//dispatch(setCanScroll(false));

		return () => {
			const scrollY = document.body.style.top;
			document.body.style.position = '';
			document.body.style.top = '';

			window.scrollTo(0, parseInt(scrollY || '0') * -1);
		};
	}, []);

	return (
		<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="popup">
			<motion.div initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: 30 }} className="window">
				{children}
				<div onClick={() => handleClose(false)} className="popup-btn">
					<SvgIcon icon="icon-ios-close-empty" />
				</div>
			</motion.div>
		</motion.div>
	);
};

export default Popup;
